import { useRef, useCallback } from 'react';
// export function smartSplitWithBracket(input) {
//   const result = [];

//   // Normalize: ensure symbols like †, +, * get separated
//   const normalized = input
//     .replace(/-\*/g, '-|')     // Replace -* with a split marker
//     .replace(/([†+])/g, '|')   // Split on † or +
//     .replace(/([()])/g, '|$1|'); // Keep brackets isolated

//   const rawParts = normalized.split('|').map(part => part.trim()).filter(Boolean);

//   // Reconstruct: Merge bracketed codes and valid ICD codes
//   const merged = [];
//   for (let i = 0; i < rawParts.length; i++) {
//     const part = rawParts[i];
//     if (part.startsWith('(')) {
//       let bracket = part;
//       while (!bracket.endsWith(')') && i + 1 < rawParts.length) {
//         i++;
//         bracket += rawParts[i];
//       }
//       merged.push(bracket);
//     } else {
//       merged.push(part);
//     }
//   }

//   return merged;
// }

export function smartSplitWithBracket(input) {
  const result = [];
 
  // Normalize: ensure symbols like †, +, * get separated
  const normalized = input
    .replace(/-\*/g, '-|')     // Replace -* with a split marker
    .replace(/([†+])/g, '|')   // Split on † or +
    .replace(/([()])/g, '|$1|'); // Keep brackets isolated
 
  const rawParts = normalized.split('|').map(part => part.trim()).filter(Boolean);
 
  // Reconstruct: Merge bracketed codes and valid ICD codes
  const merged = [];
  for (let i = 0; i < rawParts.length; i++) {
    const part = rawParts[i];
    if (part.startsWith('(')) {
      let bracket = part;
      while (!bracket.endsWith(')') && i + 1 < rawParts.length) {
        i++;
        bracket += rawParts[i];
      }
      merged.push(bracket);
    } else {
      merged.push(part);
    }
  }
 
  // Remove parentheses from each part
  return merged.map(part => part.replace(/[()]/g, ''));
}

export function getPrimaryCode(codes) {
  if (!Array.isArray(codes) || codes.length === 0) return "";

  const clean = (code) =>
    code.replace(/[+*†]+$/, '').replace(/^\(|\)$/g, '').trim();

  // Filter out codes ending with - or -*
  const primaryCandidates = codes.filter(code =>
    !code.endsWith('-') && !code.endsWith('-*')
  );

  // Prioritize non-bracketed ICD codes
  for (let c of primaryCandidates) {
    if (!/^\(.*\)$/.test(c)) return clean(c);
  }

  // If only morphology or invalid codes, return best available
  return clean(primaryCandidates[0] || codes[0]);
}


export function prioritizeParts(parts) {
  const priorityOrder = ["†","-", "*"];
  const prioritized = [];

  // Make a copy so we don't mutate the original
  const remaining = [...parts];

  // Go through priority symbols
  priorityOrder.forEach((symbol) => {
    const index = remaining.findIndex((p) => p.includes(symbol));
    if (index !== -1) {
      // Remove from remaining and push to prioritized
      prioritized.push(remaining.splice(index, 1)[0]);
    }
  });

  // Add any remaining codes at the end
  return [...prioritized, ...remaining];
}

// utils/clusterIdGenerator.js

// let currentId = 'A';
let isNewSession = true;

// utils/clusterIdGenerator.js

export const useClusterIdGenerator = () => {
  const clusterIdRef = useRef(null);

  const loadFromStorage = useCallback(() => {
    try {
      const stored = sessionStorage.getItem('codeSearch_clusterId');
      return stored || 'A';
    } catch (error) {
      console.warn('Failed to load cluster ID from storage:', error);
      return 'A';
    }
  }, []);

  const saveToStorage = useCallback((id) => {
    try {
      sessionStorage.setItem('codeSearch_clusterId', id);
    } catch (error) {
      console.warn('Failed to save cluster ID to storage:', error);
    }
  }, []);

  const getNextClusterId = useCallback((id) => {
    if (!id) return 'A';
    
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let idArray = id.split('');
    
    for (let i = idArray.length - 1; i >= 0; i--) {
      const currentChar = idArray[i];
      const currentIndex = chars.indexOf(currentChar);
      
      if (currentIndex < chars.length - 1) {
        idArray[i] = chars[currentIndex + 1];
        for (let j = i + 1; j < idArray.length; j++) {
          idArray[j] = 'A';
        }
        return idArray.join('');
      }
    }
    
    return 'A' + 'A'.repeat(idArray.length);
  }, []);

  const getCurrentId = useCallback(() => {
    if (!clusterIdRef.current) {
      clusterIdRef.current = loadFromStorage();
    }
    return clusterIdRef.current;
  }, [loadFromStorage]);

  const generateNextId = useCallback(() => {
    const current = getCurrentId();
    const nextId = getNextClusterId(current);
    clusterIdRef.current = nextId;
    saveToStorage(nextId);
    return nextId;
  }, [getCurrentId, getNextClusterId, saveToStorage]);

  const reset = useCallback(() => {
    clusterIdRef.current = 'A';
    saveToStorage('A');
  }, [saveToStorage]);

  const isNewSession = useCallback(() => {
    return getCurrentId() === 'A';
  }, [getCurrentId]);

  return {
    getCurrentId,
    generateNextId,
    reset,
    isNewSession,
  };
};


// utils/clusterIdGenerator.js
// utils/clusterIdGenerator.js - Enhanced version

let currentId = 'A';
export const clusterIdGenerator = {
  getNext: (existingIds = []) => {
    // If we have existing IDs, find the next one after the highest existing
    if (existingIds && existingIds.length > 0) {
      const sortedIds = [...existingIds].sort();
      const highestExisting = sortedIds[sortedIds.length - 1];
      currentId = highestExisting;
    }
    
    const id = currentId;
    
    // Increment the ID
    if (currentId.length === 1) {
      if (currentId === 'Z') {
        currentId = 'AA';
      } else {
        currentId = String.fromCharCode(currentId.charCodeAt(0) + 1);
      }
    } else {
      const firstChar = currentId[0];
      const secondChar = currentId[1];
      
      if (secondChar === 'Z') {
        currentId = String.fromCharCode(firstChar.charCodeAt(0) + 1) + 'A';
      } else {
        currentId = firstChar + String.fromCharCode(secondChar.charCodeAt(0) + 1);
      }
    }
    
    return id;
  },
  
  reset: () => {
    currentId = 'A';
  },
  
  getCurrent: () => {
    return currentId;
  }
};
